<template>
  <div>
    <div
      v-if="justView"
      :class="`width--max-content padding-x-8 padding-y-4 border-radius-4 cursor--pointer font-size-12 background-${status.backgroundColor} color-${status.color}`"
    >
      <span>{{ status.caption }}</span>
    </div>
    <div
      v-if="!justView"
      :class="`flex-between width-percent-100 padding-x-16 padding-y-8 border-radius-4 cursor--pointer font-size-12 background-double-light-gray color-complementary-300`"
    >
      <span>{{ $lang.indicatorStatus }}</span>
      <DropdownModal
        v-if="!justView"
        :disabled="!hasItemPermission(['INDICATOR_STATUS'])"
        :modalWidth="188"
      >
        <template #click-area>
          <div
            :class="`flex-end padding-x-8 padding-y-4 border-radius-4 cursor--pointer font-size-12 background-${status.backgroundColor} color-${status.color}`"
          >
            <span>{{ status.caption }}</span>
            <span class="margin-right-8 flex">
              <mdicon v-if="loading" name="loading" size="20" class="spinner" />
              <mdicon v-else name="chevron-down" size="16" />
            </span>
          </div>
        </template>
        <template #content>
          <ul
            class="margin-0 padding-0 list-style--none font-size-14 color-complementary-400"
          >
            <li
              v-for="(statusItem, index) in statusItems"
              :key="`a-${index}`"
              class="border-radius-4 padding-x-8 padding-y-4 margin-bottom-16"
              :class="{
                'background-complementary-50 color-surface cursor--not-allowed':
                  !statusItem.show,
                'is-hover': statusItem.show,
              }"
              @click.stop="setStatus(statusItem, item.id)"
            >
              {{ statusItem.caption }}
            </li>
          </ul>
        </template>
      </DropdownModal>
    </div>
  </div>
</template>

<script>
import { DropdownModal } from "@/components/re-design";
import { pathOr } from "ramda";
import { computed, inject, ref, toRefs } from "vue";
import { generateError } from "@/shared/utils";
import { setCompetencyIndicatorStatus } from "@/modules/kanoon/services";
export default {
  components: { DropdownModal },
  props: {
    item: {
      type: Object,
      default: null,
    },
    justView: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    // generate props data
    const { item } = toRefs(props);

    const centerExecuteId = inject("CENTER_EXECUTE_ID");
    const caseId = inject("CASE_ID");
    const competencyId = inject("COMPETENCY_ID");
    const hasItemPermission = inject("hasItemPermission");
    const getIndicators = inject("GET_INDICATORS");

    const hasCheckedItemEvidence = computed(() => {
      const evidences = pathOr([], ["evidences"], item.value);
      return evidences.some(({ isSelect }) => isSelect);
    });

    const statusItems = computed(() => [
      {
        id: -1,
        caption: "عدم امکان احراز",
        backgroundColor: "complementary-50",
        color: "complementary-300",
        show: !hasCheckedItemEvidence.value,
      },
      {
        id: 0,
        caption: "احراز نشده",
        backgroundColor: "error-100",
        color: "error-900",
        show: !hasCheckedItemEvidence.value,
      },
      {
        id: 1,
        caption: "احراز شده",
        backgroundColor: "success-50",
        color: "success",
        show: hasCheckedItemEvidence.value,
      },
      {
        id: 2,
        caption: "احراز قوی",
        backgroundColor: "success-100",
        color: "success-900",
        show: hasCheckedItemEvidence.value,
      },
    ]);
    const statusId = computed(() => pathOr(-1, ["statusId"], item.value));
    const currentStatus = computed(() =>
      statusItems.value.find(({ id }) => id === statusId.value)
    );
    const status = ref(currentStatus);
    const loading = ref(false);
    const setStatus = async (statusItem, indicatorId) => {
      const { show } = statusItem;
      if (!show) return;

      try {
        loading.value = true;
        await setCompetencyIndicatorStatus({
          centerExecuteId: centerExecuteId.value,
          caseId: caseId.value,
          competencyId: competencyId.value,
          indicatorId,
          statusId: statusItem.id,
        });
        status.value = statusItem;
        getIndicators();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    // return data to be used in template
    return {
      item,
      statusItems,
      status,
      setStatus,
      pathOr,
      hasCheckedItemEvidence,
      loading,
      hasItemPermission,
    };
  },
};
</script>
